import { render } from "./LicenseCircle.vue?vue&type=template&id=585a3d7a&ts=true"
import script from "./LicenseCircle.vue?vue&type=script&lang=ts"
export * from "./LicenseCircle.vue?vue&type=script&lang=ts"

import "./LicenseCircle.vue?vue&type=style&index=0&id=585a3d7a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__